import {
  Box,
  IconCalendarDelete,
  IconCalendar,
  MediaObject,
  Stack,
  Text,
  useDevice,
} from '@treatwell/ui';
import {Trans, useTranslation} from 'react-i18next';
import styles from './SalonSuggestionLink.module.css';
import {
  BrowseOtherSalonClickedTriggerContext,
  generateBrowseOtherSalonClickedAttributes,
} from '../../../utils/generateBrowseOtherSalonClickedAttributes';
import {store} from '../../../store';
import {trackEvent} from '../../../utils/mParticleTracking';

const BrowseLink = ({
  children,
  triggerContext,
  className,
}: {
  children: React.ReactElement | string;
  triggerContext: BrowseOtherSalonClickedTriggerContext;
  className: string;
}) => {
  const {isMobile} = useDevice();
  const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const eventAttributes = generateBrowseOtherSalonClickedAttributes({
      state: store.getState(),
      isMobile,
      triggerContext,
    });
    trackEvent({
      eventName: 'browse_other_salon_clicked',
      eventAttributes,
    });

    window.location.href = '/places';
  };
  return (
    <a
      href="/places"
      className={className}
      onClick={onClick}
      data-cy="BrowseOtherSalonLink"
    >
      {children}
    </a>
  );
};

const BrowseButtonLink = ({
  title,
  subtitle,
  icon,
  triggerContext,
}: {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  triggerContext: BrowseOtherSalonClickedTriggerContext;
}) => (
  <div className={styles.container}>
    <BrowseLink triggerContext={triggerContext} className={styles.button}>
      <Box padding="base" paddingWide="base">
        <MediaObject align="center">
          <div className={styles.iconContainer}>{icon}</div>
          <Stack space="sm">
            <Text type="bodyHeavy">{title}</Text>
            <Text type="caption">{subtitle}</Text>
          </Stack>
        </MediaObject>
      </Box>
    </BrowseLink>
  </div>
);

export const NoResults = () => {
  const {t} = useTranslation();
  return (
    <BrowseButtonLink
      title={t('salonSuggestions.noResultsButton.title')}
      subtitle={t('salonSuggestions.noResultsButton.subtitle')}
      icon={<IconCalendarDelete size={24} />}
      triggerContext="availability/back_to_search"
    />
  );
};

export const SomeResults = () => {
  const {t} = useTranslation();
  return (
    <BrowseButtonLink
      title={t('salonSuggestions.withTimeslotsButton.title')}
      subtitle={t('salonSuggestions.withTimeslotsButton.subtitle')}
      icon={<IconCalendar size={24} />}
      triggerContext="availability/browse_other_salon"
    />
  );
};

export const FindOther = () => (
  <Text>
    <BrowseLink
      triggerContext="availability/browse_more_results"
      className={styles.link}
    >
      <Trans i18nKey="salonSuggestions.findOther">Find other venues</Trans>
    </BrowseLink>
  </Text>
);
